export default __webpack_public_path__ + "static/media/Emm_light.19a8f69f.png";